(function(app) {

    app.filter("parseInt",
        [
            function(input) {
                return parseInt(input, 10);
            }
        ]);

})(window.app); //jshint ignore:line